import { JsonObject } from '../../helpers';
import { ConnectorApiKeyConfig, ConnectorFeatureSet } from './';
import OpenAIIcon from '@/assets/connector-icons/openai.png';
import { ConnectorModel } from './connector.model';

export class OpenAIConnectorModel extends ConnectorModel {
  config: ConnectorApiKeyConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'openai';
    this.typeLabel = 'OpenAI';
    this.iconSVG = OpenAIIcon;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };

    this.config = (data.config as ConnectorApiKeyConfig) || {
      apiKey: '',
    };

    this.configSecrets = ['apiKey'];
    this.canListProviderModels = true;
  }
}
